<template>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :width="width" :height="height" viewBox="0 0 36 36">
        <defs>
            <clipPath id="clip-Light">
                <rect width="36" height="36"/>
            </clipPath>
        </defs>
        <g id="Light" clip-path="url(#clip-Light)">
            <g id="Group_4" data-name="Group 4" transform="translate(-1117 -16)">
                <rect id="Rectangle_38840" data-name="Rectangle 38840" width="36" height="36" transform="translate(1117 16)" fill="#212121" opacity="0"/>
                <path id="Path_4427" class="svg-outline-color" data-name="Path 4427" d="M18,0A18,18,0,1,1,0,18,18,18,0,0,1,18,0m0,35A17,17,0,1,0,1,18,17.024,17.024,0,0,0,18,35" transform="translate(1117 16)" fill="#d4d4d4"/>
                <path id="Path_4428" class="svg-secondary-color" data-name="Path 4428" d="M24,8H12a2.006,2.006,0,0,0-2,2V26a2.006,2.006,0,0,0,2,2H24a2.006,2.006,0,0,0,2-2V10a2.006,2.006,0,0,0-2-2M13.99,13h4v1h-4Zm8,10h-8V22h8Zm0-3h-8V19h8Zm0-3h-8V16h8Z" transform="translate(1117 16)" fill="#212121"/>
            </g>
        </g>
    </svg>


</template>

<script>
export default {
    name: "assessmentIcon",
    props: {
        width: {
            type: Number,
            default: 36
        },
        height: {
            type: Number,
            default: 36
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/common/components/svg/shared/assessmentIcon.vue